import Dropdown from '../../../../../../Components/Form/Inputs/Dropdown';
import useLanguage from '../../../../../../Services/Language/useLanguageHook';
import { SlidingWindowSeasonalParameters, UpsertMarketIndicatorFactorRequest, windowEndDayOptions } from '../../../MarketIndicatorsManagementDefinitions';
import styles from '../../MarketIndicatorFactorPage.module.scss';

interface IMarketFactorWindowEndDayDropdownProps {
    upsertMarketIndicatorFactorRequest: UpsertMarketIndicatorFactorRequest;
    setUpsertMarketIndicatorFactorRequest: (value: UpsertMarketIndicatorFactorRequest) => void;
}

const MarketFactorWindowEndDayDropdown: React.FC<IMarketFactorWindowEndDayDropdownProps> = (props: IMarketFactorWindowEndDayDropdownProps) => {
    const [translations] = useLanguage();

    return (
        <div className={styles.indicator_add_and_edit_dropdown}>
            <Dropdown
                value={(props.upsertMarketIndicatorFactorRequest.parameters as SlidingWindowSeasonalParameters).windowEndDay}
                handleOptionChange={(value) => {
                    props.setUpsertMarketIndicatorFactorRequest({
                        ...props.upsertMarketIndicatorFactorRequest,
                        parameters: {
                            ...props.upsertMarketIndicatorFactorRequest.parameters,
                            windowEndDay: value,
                        },
                    });
                }}
                options={windowEndDayOptions.filter(
                    (x) => +(props.upsertMarketIndicatorFactorRequest.parameters as SlidingWindowSeasonalParameters).windowStartDay <= +x.value,
                )}
                label={translations.marketIndicatorsManagement.fields.windowEndDay}
                track={{
                    eventCategory: 'MarketIndicatorFactor',
                    eventAction: 'WindowEndDayChanged',
                    eventValue: (props.upsertMarketIndicatorFactorRequest.parameters as SlidingWindowSeasonalParameters).windowEndDay,
                }}
            />
        </div>
    );
};

export default MarketFactorWindowEndDayDropdown;
